import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Redirect, withRouter } from 'react-router-dom';
import { Trans } from 'react-i18next';
import i18n from '../../i18n';
import UserAccountMenu from "./UserAccountMenu"
import LoginLogout from './LoginLogout';
import { getBaseUrl } from '../util/HelpfulFunctions';
import SessionManager from '../util/SessionManager';

class Navbar extends Component {

  toggleOffcanvas() {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
  }

  toggleRightSidebar() {
    document.querySelector('.right-sidebar').classList.toggle('open');
  }

  render () {     

    return (
      <nav className="navbar col-lg-12 col-12 p-lg-0 fixed-top d-flex flex-row">
        <div className="navbar-menu-wrapper d-flex align-items-center justify-content-between">
        <a className="navbar-brand brand-logo-mini align-self-center d-lg-none" href="!#" onClick={evt =>evt.preventDefault()}><img src={getBaseUrl() + "/assets/logo-mini.svg"} alt="logo" /></a>
          
          <button className="navbar-toggler navbar-toggler align-self-center" type="button" onClick={ () => document.body.classList.toggle('sidebar-icon-only') }>
            <i className="mdi mdi-menu color-primary"></i>
          </button>

          {/* <form className="ml-auto search-form d-none d-md-block" action="#">
            <div className="form-group">
              <input type="search" className="form-control" placeholder={i18n.t("Αναζήτηση")} />
            </div>
          </form> */}

          <ul className="navbar-nav navbar-nav-right">
            <li className="nav-item  nav-profile border-0">
              <UserAccountMenu />
            </li>
          </ul>

          <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" onClick={this.toggleOffcanvas}>
            <span className="mdi mdi-menu color-primary"></span>
          </button>

        </div>
      </nav>
    );

  }

}

export default withRouter(Navbar);
